export default class BergerLevrault {

	constructor(id, localAuthorityId, code, enabled) {
		this.id               = id
		this.localAuthorityId = localAuthorityId
		this.code             = code
		this.enabled          = enabled
	}

	static createFromJson(json) {
		if (!json) return null;
		return new BergerLevrault(json.id, json.localAuthorityId, json.code, json.enabled);
	}
}


// WEBPACK FOOTER //
// ./src/model/berger-levrault.js